import { Outlet } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Container } from '@mui/material';

function LiffLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            SRU Alumni - LINE App
          </Typography>
        </Toolbar>
      </AppBar>
      
      <Container component="main" sx={{ flex: 1, py: 2 }}>
        <Outlet />
      </Container>
    </Box>
  );
}

export default LiffLayout;
